import KardiaRxCCTWorkList from './KardiaRxCCTWorkList';

export default KardiaRxCCTWorkList;



// WEBPACK FOOTER //
// ./src/views/pages/KardiaRxCCTWorkList/index.js